import React, { useState } from 'react'
import PropTypes from 'prop-types'

// Components - imported
import { Avatar, Button } from '@material-ui/core';

// Icons
import AddAPhotoOutlinedIcon from '@material-ui/icons/AddAPhotoOutlined';
import CloudUploadIcon from '@material-ui/icons/CloudUpload';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';

const AddLogo_Team_1 = ({
    slideform3, 
    setSlideForm3,
    slideform4, 
    setSlideForm4,
    setAlert,
    handleSubmit,
    is_create_page,
    setLogo_Team1,
    processing
}) => {

    // State variable to store the file URL
    const [fileUrl, setFileUrl] = useState('');

    // Function to trigger the file upload button
    const fileUploadButton = () => {
        document.getElementById('fileButton_1').click();
    }

    // Event handler for file selection
    const fileChanged = async e => {

        // Array to store the selected files
        let fileList = [];

        // Iterate through the selected files
        for (var i = 0; i < e.target.files.length; i++) {

            if(!e.target.files[i]) return;

            const fileName = e.target.files[i].name;

            // --- File extension

            const fileExt = fileName.substring(fileName.lastIndexOf('.')+1, fileName.length)
            console.log('File ext: ', fileExt);

            if(!(fileExt.includes('jpeg') || fileExt.toLowerCase().includes('jpg') || fileExt.includes('png') || fileExt.includes('gif'))) {
                setAlert('Only photos are allowed!', 'danger');
                return;
            }

            // --- END File extension
            
            // Add the file to the fileList array
            fileList.push(e.target.files[i])

            let reader = new FileReader()

            // Read the file as data URL
            reader.readAsDataURL(e.target.files[i])
            reader.onload = () => {
                console.log('FILE PATH')

                // Display the file path (data URL)
                console.log(reader.result);

                // Update the file URL state with the new data URL
                setFileUrl(fileUrl => [...fileUrl, reader.result])
            };
            
            // Display if there is an error reading the file
            reader.onerror = function (error) {
                console.log('Error: ', error);
            }
        }

        setLogo_Team1(fileList[0]);
    }

    // Go back to the previous form step
    const goBack = (e) => {
        setSlideForm3(!slideform3);
    }

    // Toggle the slideform1 state variable (go to next page in slide form)
    const todo = (e) => {
        setSlideForm4(!slideform4);
    }

    return (
        <div className="form-transition-element">

            {/* Back Button */}
            {!is_create_page && (
                <div onClick={goBack} className="form__backBtn">
                    <ArrowBackIcon />
                </div>
            )}
            

            {/* Display the heading */}
            <div>
                <h2>Add Team 1 Logo</h2>
            </div>

            <div className="profile-modal__avatar" style={is_create_page ? {paddingTop: '16px'} : {}}>

                {/* Render an overlay with an icon to trigger the file upload */}
                <div onClick={fileUploadButton} className="profile__avatar__overlay">
                    <AddAPhotoOutlinedIcon />
                </div>

                {/* Render an Avatar component with the uploaded file URL or the user's existing image */}
                <Avatar 
                    src={fileUrl} 
                />

                {/* Render a hidden input element to handle file selection */}
                <input
                    onChange={fileChanged} 
                    id="fileButton_1" 
                    type="file" 
                    accept="image/png, image/gif, image/jpeg, image/jpg"
                    hidden
                />
            </div>

            {/* Slide Form Actions */}
            {/* If not profile img then give the option to 'Skip' */}
            {/* If there is an img then say 'Next' */}
            {fileUrl !== ''  ? (
                <Button 
                    disabled={processing}
                    onClick={todo}
                    variant="outlined" 
                    className={`sidebar__tweet ${fileUrl === '' ? 'ghost' : 'black'}`}
                    fullWidth
                >
                    {processing ? 'processing...' : 'Next'}
                </Button>
            ) : (
                <Button 
                    onClick={fileUploadButton}
                    variant="outlined" 
                    className={`sidebar__tweet`}
                    fullWidth
                >
                    Upload Picture
                    <span style={{width: '5px'}}></span>
                    <CloudUploadIcon />
                </Button>
            )}
            <Button 
                onClick={goBack}
                variant="outlined" 
                className="sidebar__tweet heart"
                fullWidth
            >
                Go Back
            </Button>

        </div>
    )
}

AddLogo_Team_1.propTypes = {

}

export default AddLogo_Team_1
